module.exports = __webpack_public_path__ + "img/lulu-layer.9f6b4952.png";